export function isUidNameConflictError(err) {
  const data = err?.response?.data;
  const nested = data?.message;
  const code =
    data?.code ||
    (typeof nested === 'object' && nested !== null ? nested.code : null);
  return code === 'UID_NAME_CONFLICT_IN_PROJECT';
}

export function uidNameConflictMessage(err, fallback) {
  const data = err?.response?.data;
  const msg = data?.message;
  if (typeof msg === 'string') return msg;
  if (typeof msg === 'object' && msg !== null && typeof msg.message === 'string') {
    return msg.message;
  }
  return fallback;
}
